import {
  GET_PROJECT_QA_NDT_BOOKINGS_NDT_TYPES,
  GET_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE,
  CREATE_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE,
  UPDATE_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE,
  DESTROY_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE,
} from "./actions";

export function ProjectQaNdtBookingsNdtTypesReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_PROJECT_QA_NDT_BOOKINGS_NDT_TYPES}_FULFILLED`: {
      return _.mapKeys(action.payload.data, "id");
    }
    case `${GET_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE}_FULFILLED`:
    case `${CREATE_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE}_FULFILLED`:
    case `${UPDATE_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE}_FULFILLED`: {
      let newState = _.clone(state);
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      newState[id] = newItem;
      return newState;
    }
    case `${DESTROY_PROJECT_QA_NDT_BOOKINGS_NDT_TYPE}_FULFILLED`: {
      let newState = _.clone(state);
      const deletedItem = action.payload.data;
      const id = _.get(deletedItem, "id");
      newState = _.filter(newState, (i) => i.id != id);
      return newState;
    }
    default:
      return state;
  }
}
